export function getStockEntryQuantity(value: unknown): number {
  if (value === null || value === undefined || value === "") return 0;
  const qty = typeof value === "number" ? value : Number(value);
  return Number.isFinite(qty) && qty > 0 ? qty : 0;
}

export function getDefaultStockEntryQuantity(xmlQuantity: number, alreadyImported: boolean): number {
  return alreadyImported ? 0 : getStockEntryQuantity(xmlQuantity);
}
